function addToCart(variantId, quantity = 1) {
    return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: quantity
            }]
        })
    })
        .then(res => {
            return fetch(window.routes.cart_url + '.js');
        })
        .then(res => res.json())
        .then(cart => {
            window.dispatchEvent(new CustomEvent('cart-updated', {
                detail: {
                    count: cart.item_count,
                    cart: cart
                }
            }));
            return cart;
        });
}

// Make it globally available
window.addToCart = addToCart;
